import * as React from "react";
const MenuIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 16H25M7 10H25M13 22H25"
      stroke="#344054"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default MenuIcon;
